import { Injectable } from '@angular/core';
import { ApiConService } from '../shared/api-con.service';
import { BoxListTruckService } from '../box-list-truck/box-list-truck.service';
import { JsonReturn } from '../shared/interface/generic-interface';

@Injectable()
export class BoxHistoricoAcoesService {

  listHistoryAction: any;
  constructor(
    private conService: ApiConService,
    private boxListTruckService: BoxListTruckService
  ) { }

  async getHistoryAction() 
  {
    try 
    {
      const response: JsonReturn = await this.conService.patch('DCcoordenadas/' + this.boxListTruckService.roteiroSelecionado);
      this.listHistoryAction = response.response;
    }
    catch (Error) 
    { 
      console.log('getHistoryAction');
      console.log(Error);
    }
  }

  async getListaDeAcoes(){
    try{
      let response: JsonReturn =  await this.conService.patch(`DCcoordenadas/listaDeAcoes/${this.boxListTruckService.roteiroSelecionado}`);
      return response.response;
    }catch (Error) {
      console.log('getListaDeAcoes');
      console.log(Error);
      return [];
    }
  }

  async getListaDeAcoesPorPedido(codigoCliente){
    try{
      let response: JsonReturn =  await this.conService.patch('DCcoordenadas/listaDeAcoesLogPedido/' + this.boxListTruckService.roteiroSelecionado+ '/' + codigoCliente);
      return response.response;
    }catch (Error) {
      console.log('getListaDeAcoesPorPedido');
      console.log(Error);
      return [];
    }
  }
}
